<template lang="html">
  <div class="legal">
    <p v-html="$ml.get('legal.text')" />
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Legal.vue